import React, { useState, useEffect, useRef } from 'react';
import { Fade } from 'react-reveal';
import { Badge, Button } from 'reactstrap';
import moment from 'moment';
import Masonry from 'react-masonry-css';

const breakpointColumnsObj = {
  default: 4,
  // 1100: 4,
  700: 3,
  500: 2,
};

const ReviewCards = (props: any) => {
  const { reviews } = props;

  const [page, setPage] = useState(1);
  const [showButton, setShowButton] = useState(true);
  const [displayedReviews, setDisplayedReviews] = useState([]);
  const size = 10;
  const prevPageRef = useRef(page);

  useEffect(() => {
    setDisplayedReviews(reviews.slice(0, page * size));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (page !== prevPageRef.current) {
      prevPageRef.current = page;
      if (reviews.slice(0, page * size).length < reviews.length) {
        setDisplayedReviews(reviews.slice(0, page * size));
      } else {
        setDisplayedReviews(reviews.slice(0, page * size));
        setShowButton(false);
      }
    }
  });

  const handleMoreClick = () => {
    setPage((prev) => prev + 1);
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const capitalizeLastName = (string) => {
    return string.charAt(0).toUpperCase() + '.';
  };

  return (
    <div className="mt-5">
      <Fade bottom>
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {displayedReviews.map(
            (review, i) =>
              i < page * 10 && (
                <div key={review._id}>
                  <div className=" border" style={{ cursor: 'default' }}>
                    {review.reviewImage && review.reviewImage !== '' && (
                      <img
                        className="img-fluid position-relative"
                        style={{ objectFit: 'cover' }}
                        src={review.reviewImage}
                        alt={review.review}
                      />
                    )}

                    <div className="p-3">
                      <h5 className="m-0 d-inline">
                        {capitalizeFirstLetter(review.firstName)}{' '}
                        {capitalizeLastName(review.lastName)}{' '}
                      </h5>
                      {review.userId.isActive && (
                        <h6 className="m-0 d-inline">
                          <Badge size="sm" color="success">
                            {' '}
                            <i className="fas fa-check"></i> Verified
                          </Badge>
                        </h6>
                      )}
                      <p className="m-0 text-muted">
                        {' '}
                        {moment(review.lastUpdated).format('Do MMM YY')}
                      </p>
                      <span style={{ fontSize: '18px', display: 'inline-block' }}>
                        {[...Array(Math.ceil(review.rating))].map((star, index) => (
                          <i
                            key={index}
                            className="fas fa-star"
                            style={{ fontSize: 15, color: 'gold' }}
                          ></i>
                        ))}
                        {[...Array(Math.ceil(5 - review.rating))].map((star, index) => (
                          <i
                            key={index}
                            className="far fa-star"
                            style={{ fontSize: 15, color: 'gold' }}
                          ></i>
                        ))}
                      </span>
                      <br />
                      {capitalizeFirstLetter(review.review)}
                    </div>
                  </div>
                </div>
              )
          )}
        </Masonry>
        <div className=" text-center">
          {reviews.length > 10 && showButton && (
            <Button onClick={handleMoreClick} className="border" outline color="dark">
              Read More
            </Button>
          )}
        </div>
      </Fade>
    </div>
  );
};

export default ReviewCards;
